import { event as gtagEvent } from 'vue-gtag'
import i18n from "../../i18n"

export default {

  trackEvent(context, { action, label = null, value = null }) {
    let hostname = process.env.VUE_APP_TYPE === "distributor" ? ' - ' + window.location.hostname : '';
    if (process.env.VUE_APP_TRACKING_ENABLED == 'true') {
      gtagEvent(action, {
        "event_category": context.state.analyticsToolName + " - " + context.state.host + hostname,
        "event_label": label,
        "value": value
      });
    }
    else { 
      // eslint-disable-next-line
      console.log("%cTracking Event:", "background:#41b883; padding:1px 3px; border-radius:3px; color:#fff", { action: action, event_category: context.state.analyticsToolName + " - " + context.state.host + hostname, event_label: label, value: value });
    }
  },

  // Mobile --------------------------------------------------------------------
  updateMobile(context, width) {
    if (width < 768) {
      if (!context.state.isMobile) {
        context.commit("turnOnMobile");
      }
    } else if (context.state.isMobile) {
      context.commit("turnOffMobile");
    }
  },


  // Preselection -------------------------------------------------------------------

  updatePreselectionBox(context, { sourceBox, isSelected }) {
    context.commit("updatePreselectionBox", { sourceBox, isSelected })
  },

  updateMultiPreselectionBox(context, { sourceLevel, sourceRow, sourceBox, isSelected }) {
    context.commit("updateMultiPreselectionBox", { sourceLevel, sourceRow, sourceBox, isSelected })
  },

  preselectionBoxClick(context, { sourceLevel, sourceRow, sourceBox, targetLevel, targetRow }) {

    if (context.state.preselection[sourceLevel][sourceRow].boxes[sourceBox].isSelected) {
      // If already selected, unselect
      context.commit("unselectPreselectionBoxClick", { sourceLevel, sourceRow, sourceBox });
    } else {
      // Else, go ahead and select the box
      context.commit("selectPreselectionBoxClick", { sourceLevel, sourceRow, sourceBox, targetLevel, targetRow });

      let label = getPreselectionClickLabel(context, sourceLevel, sourceRow, sourceBox);

      context.dispatch("trackEvent", {
        action: `Click - Pre-selection level${sourceLevel + 1}`,
        label: label
      })
    }
  },
      
}

// Format data for submitting to Google Analytics
function getPreselectionClickLabel(context, sourceLevel, sourceRow, sourceBox) {

  // Get human names for the rows and boxes
  let rowName = "";
  let boxName = "";
  let label = "";

  if (sourceLevel > 0) { // no need to worry about row name if source level is 0.  There is olways only one row.
  // Get selected box of the previous level
    rowName = i18n.global.t(context.state.preselection[sourceLevel - 1].find(x => x.boxes.find(y => y.isSelected)).boxes.find(x => x.isSelected).heading, "en");
  }
  if (sourceBox != null) { // This should never be null, but just in case....
    boxName = i18n.global.t(context.state.preselection[sourceLevel][sourceRow].boxes[sourceBox].heading, "en");
  }

  if (rowName && boxName) {
    label = `row: ${rowName} | box: ${boxName}`
  } else {
    label = `box: ${boxName}`
  }

  return label;
}